/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  TransferCertificateRequestMutationRequest,
  TransferCertificateRequestMutationResponse,
} from "../types/TransferCertificateRequest.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const transferCertificateRequestMutationKey = () =>
  [{ url: "/v1/certificate-request/transfer-certificate-request" }] as const

export type TransferCertificateRequestMutationKey = ReturnType<
  typeof transferCertificateRequestMutationKey
>

/**
 * @summary Transfer certificate request
 * {@link /v1/certificate-request/transfer-certificate-request}
 */
export async function transferCertificateRequest(
  data: TransferCertificateRequestMutationRequest,
  config: Partial<RequestConfig<TransferCertificateRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    TransferCertificateRequestMutationResponse,
    ResponseErrorConfig<Error>,
    TransferCertificateRequestMutationRequest
  >({
    method: "POST",
    url: `/v1/certificate-request/transfer-certificate-request`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function transferCertificateRequestMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<TransferCertificateRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = transferCertificateRequestMutationKey()
  return mutationOptions<
    ResponseConfig<TransferCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferCertificateRequestMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return transferCertificateRequest(data, config)
    },
  })
}

/**
 * @summary Transfer certificate request
 * {@link /v1/certificate-request/transfer-certificate-request}
 */
export function useTransferCertificateRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<TransferCertificateRequestMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: TransferCertificateRequestMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<TransferCertificateRequestMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? transferCertificateRequestMutationKey()

  const baseOptions = transferCertificateRequestMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<TransferCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferCertificateRequestMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<TransferCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferCertificateRequestMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<TransferCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferCertificateRequestMutationRequest },
    TContext
  >
}
